<template>
  <section style="max-width: 100rem; margin: auto;">
    <!-- title -->
    <div class="text-center">
      <h1 class="mt-5">
        Add funds Method
      </h1>
      <p class="mb-2 pb-75">
      </p>
    </div>
    <!-- Payment method -->
    <b-row class="pricing-card"> 
      <b-col
        sm="12"
        md="12"
        lg="12"
        class="mx-auto"
        center
      >
        <b-row class="match-height justify-content-md-center" >
          <b-col md="4" center v-if="enable">
            <b-card
              align="center"
            >
              <!-- img -->
              <b-img
                :src="src_vcb"
                width="300"
                height="300"
                class="mb-2 mt-2"
                alt="basic svg img"
              />
              <!--/ img -->
              <h3  class="text-success">Vietcombank</h3>

              <b-list-group flush class="mt3">
                <b-list-group-item class="d-flex">
                  <span class="mr-1">
                    <feather-icon
                      icon="UserIcon"
                      size="16"
                    />
                  </span>
                  <span>Nguyen Trung Long</span>
                </b-list-group-item>

                <b-list-group-item class="d-flex">
                  <span class="mr-1">
                    <feather-icon
                      icon="CreditCardIcon"
                      size="17"
                    />
                  </span>
                  <span>0161001597083</span>
                </b-list-group-item>

                <b-list-group-item class="d-flex">
                  <span class="mr-1">
                    <feather-icon
                      icon="MapPinIcon"
                      size="16"
                    />
                  </span>
                  <span>Chi Nhanh Hue</span>
                </b-list-group-item>

                <b-list-group-item class="d-flex">
                  <span class="mr-1">
                    <feather-icon
                      icon="DollarSignIcon"
                      size="16"
                    />
                  </span>
                  <span>Rate: 1$ = {{  Number(rate).toLocaleString('vn-VN', { style: 'currency', currency: 'VND' }) }}</span>
                </b-list-group-item>
                <b-list-group-item class="d-flex">
                  <span class="mr-1">
                    <feather-icon
                      icon="CodeIcon"
                      size="16"
                    />
                  </span>
                  <span><h4>{{userInfo.username +' ck'}}</h4></span>
                </b-list-group-item>
              </b-list-group>
              <p class="text-warning">Send payment with above code</p>
              
              <p class="text-success">Exchange Dollar to VND</p>
              <b-form-group>
                <b-input-group size="md" append="$">
                  <b-form-input
                      id="h-first-name"
                      placeholder="Dollar"
                      type="number"
                      v-model="dollar"
                      @keyup="changeAmount"
                    />
                </b-input-group>
              </b-form-group>
              

              <b-form-group>
                <b-input-group size="md" append="VND">
                  <b-form-input
                      id="h-first-name"
                      placeholder="VND"
                      type="text"
                      v-model="vnd"
                      disabled
                    />
                </b-input-group>
              </b-form-group>

              <!-- <b-button
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                block
                class="mt-2"
                variant="outline-primary"
                @click="showModal(0)"
              >
                Select
              </b-button> -->
            </b-card>
          </b-col>

          <!-- <b-col md="6" center>
            <b-card
              align="center"
            >
              <b-img
                :src="curbn.img"
                width="360"
                height="360"
                class="mb-2 mt-2"
                alt="basic svg img"
              />
              <h3  class="text-success">USDT</h3>

              <b-list-group flush class="mt3">
                <b-list-group-item class="d-flex">
                  <span class="mr-1">
                    Select Chains
                  </span>
                  <span> 
                    <b-form-select
                      size="sm"
                      :options="chains"
                      v-model="curchains"
                    ></b-form-select>
                  </span>
                </b-list-group-item>

                <b-list-group-item class="d-flex">
                  <span class="mr-1">
                    Address
                  </span>
                  <span>{{curbn.address}}</span>
                </b-list-group-item>
              </b-list-group>
              <div class="bitcion-pay-msg" style="color: red;">
                Attention： The transaction amount must <span style="text-decoration: underline">be exactly the same as the order amount</span>, otherwise the recharge will fail.<br>
                After the payment is completed, <span style="text-decoration: underline;">be sure to fill in the transaction ID</span> and click "Confirm Recharge" to recharge.
                Please note that all recharges can only be successful after all the above steps are done.
                <p style="font-weight: 600">Please don't close the current page until the payment is completed, otherwise the purchase will not be successful.</p>
                <p>The [handling fee] must be done, in case that you cannot receive the payment.</p>
              </div>
              
              <b-form-group
                  label="Transaction ID:"
                  label-for="h-first-name"
                  label-cols-md="3"
                >
                  <b-form-input
                    id="h-first-name"
                    placeholder="Please enter the transaction HASH/TXID after payment"
                    v-model="trans_id"
                  />
              </b-form-group>
              <b-button
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                block
                class="mt-2"
                variant="outline-primary"
                @click="confirmRecharge"
              >
              Confirm Recharge
              </b-button>
            </b-card>
          </b-col> -->
        </b-row>
      </b-col>

      
    </b-row>
    <!-- Payment history -->
    <add-fund-history :items="items" ref="fhis"></add-fund-history>
    <!-- <add-funds-modal :bank="select" ref="modal"></add-funds-modal> -->
  </section>
</template>

<script>
import { BRow, BCol, BCard, BImg, BButton, BCardText, BListGroup,BListGroupItem,BFormSelect, BFormGroup, BInputGroup, BInputGroupAppend, BInputGroupPrepend, BFormInput, BBadge} from 'bootstrap-vue'
import AddFundModal from './modal/AddFundsModal'
import Ripple from 'vue-ripple-directive'
import AddFundHistory from './table/AddFundHistory.vue'
import RepositoryFactory from '../../api/RepositoryFactory'
const UsersPaymentRepository = RepositoryFactory.get('userPayment')
import axios from 'axios'
export default {
  components: {
    BCard,
    BCardText,
    BRow, 
    BCol,
    BImg,
    BButton,
    BListGroup,
    BListGroupItem,
    AddFundHistory,
    "add-funds-modal":AddFundModal,
    BFormGroup, BInputGroup, BInputGroupAppend, BInputGroupPrepend,
    BFormInput, BBadge, BFormSelect
  },
  directives: {
    Ripple,
  },
  data(){
    return {
      select: 0,
      amount: 0,
      items:[],
      userInfo: this.$store.getters['auth/userInfo'],
      code: 'ck',
      rate: this.$store.getters['auth/settings'].exchange,
      src_vcb: '',
      binance: [
        {
          address: '0xb75b62f3ac80e22a7557c7ecebdc5caffb1f25c1',
          img: 'data:image/png;base64,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',
          network: 'BEP20'
        },
        {
          address: '0xb75b62f3ac80e22a7557c7ecebdc5caffb1f25c1',
          img: 'data:image/png;base64,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',
          network: 'ERC20'
        },
        {
          address: 'TGbwEMsm6wVFUQkKcS1myN9gKFQCV4U2Wh',
          img: 'data:image/png;base64,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',
          network: 'TRC20'
        },
        
      ],
      chains: [],
      curchains: "BEP20",
      trans_id: '',
      //amount: 1,
      vnd: 1,
      dollar: 1,
      //username: '',
      desc: 'dasd',
      enable: false,
    }
  },
  created(){
    this.$gtag.event('route', { path: 'add-funds' })
    axios.get(`https://pay.shadowtech.vip/qrcodevcb?key=A37mz3zA3lnA1eEZdpN8y2&price=1&note=${ this.$store.getters['auth/userInfo'].username} chuyen`).then(rs=>{
      this.src_vcb = rs.data
    })
    UsersPaymentRepository.fetch().then(rs => {
      this.items = rs.data
      setTimeout(()=>{
        this.$refs.fhis.mountData()
      },1000)
      
    })
    setTimeout(()=>{
      if(localStorage.getItem("country") == "VN")
        this.enable = true
    },3000)
    this.chains = this.binance.map(x=>x.network)
    this.vnd =  Number(1 * this.rate).toLocaleString('vn-VN', { style: 'currency', currency: 'VND' })  
    //this.username = this.$store.getters['auth/userInfo'].username
    
  },
  mounted(){
  },
  computed: {
    curbn(){
      return this.binance.find(x=>x.network == this.curchains)
    },
    // desc(){
    //   console.log(this.amount)
    //   return this.amount * this.rate
    // },
  },
  methods:{
    changeAmount(){
      //console.log(Number(this.dollar * this.rate).toLocaleString('vn-VN', { style: 'currency', currency: 'VND' })  )
    
      this.$nextTick(()=>{
        let a= Number(this.dollar * this.rate).toLocaleString('vn-VN', { style: 'currency', currency: 'VND' })
        this.vnd =  a 
      }) 
      console.log(this.vnd)
    },
    showModal(selection){
      this.select = selection
      this.$refs.modal.showModal()
    },
    updateFundList(item){
      
      this.items.unshift(item)
    },
    confirmRecharge(){
      UsersPaymentRepository.createPayment({amount: this.amount, trans_id: this.trans_id}).then(rs=>{
        if(rs.data.success){
            this.items.push(rs.data.data)
            this.amount = 0
            this.trans_id = ""
            this.$bvToast.toast("This txid has proccesing, wait for check", {
              title: "Success",
              variant:"success",
              solid: true,
            })  
          }else{
            this.$bvToast.toast(rs.data.errMsg, {
              title: "Error",
              variant:"danger",
              solid: true,
            })  
          }
      })
    }
  }
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-pricing.scss';
</style>
